/* styled-compiled.tsx generated by @compiled/babel-plugin v0.35.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import "./styled-compiled.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { N200 } from '@atlaskit/theme/colors';
var noLinkAppearanceStyles = null;
export var NoLinkAppearance = function NoLinkAppearance(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("span", _extends({}, props, {
    className: ax(["_syazpsu8"]),
    style: {
      "--_vrm7dk": ix("var(--ds-text-subtlest, ".concat(N200, ")"))
    }
  }), children);
};